import { ComponentProps, Show } from "solid-js";
import c from "class-c";

import styles from "./Line.module.scss";

declare namespace Line {
  type Props = ComponentProps<"div"> & {
    // This is necessary when Line is at the top of a container with hidden
    // overflow.
    shiftDown?: boolean;
  };
}

function Line({
  class: className,
  shiftDown,
  children,
  ...props
}: D<Line.Props>) {
  return (
    <Show
      when={children}
      fallback={
        <div
          class={c`${styles["line"]} ${shiftDown && styles["shift-down"]} ${className}`}
          {...props}
        />
      }
    >
      <div class={c`${styles["line-container"]} ${className}`}>
        <div class={styles["line"]} />
        <main class="text:small">{children}</main>
        <div class={styles["line"]} />
      </div>
    </Show>
  );
}

export default Line;
